import ContentEditable from "../../../Components/ContentEditable/ContentEditable";
import Quilleditor from "../../../Components/Quilleditor/Quileditor_New";
import Pattern from "./Pattern";

function EducationItem(props) {
  const {
    headerHtml,
    styles,
    resumeHandler,
    resumeUpdate,
    response,
    index,
    handleDatePicker,
    handleEditorChange,
    changesetShowQuillToolbar,
    showQuillToolbar,
    sectionId,
    education,
  } = props;
  return (
    <>
      <Pattern
        headerHtml={headerHtml}
        response={response}
        index={index}
        resumeHandler={resumeHandler}
        resumeUpdate={resumeUpdate}
        styles={styles}
        sectionId={sectionId}
        handleDatePicker={handleDatePicker}
        education={education}
      />
      {response && response.showFields && response.showFields.description && (
        <div className="education-description resume-description">
          <Quilleditor
            type="visual"
            showQuillToolbar={showQuillToolbar}
            changesetShowQuillToolbar={changesetShowQuillToolbar}
            theme="snow"
            className={``}
            inivalue={
              response?.description
                ? response?.description?.replace(/\n|\r/g, "")
                : ""
            }
            current={index}
            setvalue={handleEditorChange}
            onBlur={resumeUpdate}
            styles={styles}
            sectionId={sectionId}
            placeholder="A varied education on your resume sums up the value that your learnings and background will bring to job"
          />
        </div>
      )}
    </>
  );
}

export default EducationItem;
